import { useEffect } from "react"
import GoogleAutoComplete from "components/GoogleAutoComplete"
import SinglePicker from "components/Pickers/SinglePicker"
import CustomerPicker from "components/Pickers/CustomerPicker"
import CustomerLocationPicker from "components/Pickers/CustomerLocationPicker"
import { HyperDatepicker } from "components"
import { FormInput } from "../../form"
import { ProductsList } from "components/Dropdowns/ProductsList"
import { SuppliersList } from "components/Dropdowns/SuppliersList"
import SourcePicker from "components/Pickers/SourcePicker"
import TankProductPicker from "components/Pickers/TankProductPicker"
import FuelTypePicker from "components/Pickers/FuelTypePicker"
import RateStructurePicker from "components/Pickers/RateStructurePicker"
import MonitorTypePicker from "components/Pickers/MonitorTypePicker"
import LoadingNumberPicker from "components/Pickers/LoadingNumberPicker"
import ActionsFormItem from "../InputElements/ActionsFormItem"
import cn from "classnames"
import ConditionalView from "components/ConditionalView"
import styles from "./index.module.css"
import Wrapper from "./FromItemWrapper"
import "./index.css"
import classNames from "classnames"
import LoadingNumberItem from "components/LoadingNumberItem"
import ProductDisplay from "components/ProductDisplay"
import PriceInput from "components/PriceInput"
import TerminalPicker from "../FormComponents/TerminalPricker"
import CommonCarrierPicker from "components/Pickers/CommonCarrierPicker"
import MultiEmailInput from "components/MultiEmailInput"
import dayjs from "dayjs"
import LocationTankPicker from "components/Pickers/LocationTankPicker"
import SalespersonPicker from "components/Pickers/SalespersonPicker"

type MONITOR_SELECT = {
  value: string
  __isNew__?: boolean
  data?: { id: number; port: string; password: string; type: string }
}

const FormItem = (props: any) => {
  useEffect(() => props.onMount?.(), [])

  if (props.type === "display") {
    return (
      <div className={cn("flex items-center", props.className)}>
        <span>{props.selected ?? props.defaultValue}</span>
      </div>
    )
  }

  if (props.type === "loading_number_display") {
    return <LoadingNumberItem load={props.selected} />
  }
  if (props.type === "product_display") {
    return (
      <Wrapper {...props}>
        <ProductDisplay
          prefix={props.prefix}
          className={props.className}
          id={props.selected}
        />
      </Wrapper>
    )
  }
  if (props.type === "actions") {
    return (
      <ActionsFormItem
        loading={props.loading}
        adding={props.adding}
        onChange={props.onChange}
      />
    )
  }

  if (props.type === "rate_structure_type") {
    return (
      <Wrapper {...props}>
        <RateStructurePicker
          isDisabled={props.displayOnly}
          flush={props.flush}
          selected={props.selected}
          onSelect={(e: any) => props.onChange({ [props.name]: e.value })}
        />
      </Wrapper>
    )
  }

  if (props.type === "salesperson") {
    return (
      <Wrapper {...props}>
        <SalespersonPicker
          controlStyle={props.controlStyle}
          placeholder={props.placeholder}
          errorText={props.errors?.[props.name]}
          customer_id={props.customer_id}
          selectFirst={props.options?.selectFirst}
          isDisabled={props.disabled}
          selected={props.selected}
          onSelect={(e: any) => props.onChange({ ...(e?.data ?? {}) })}
        />
      </Wrapper>
    )
  }

  if (props.type === "commonCarrier") {
    return (
      <CommonCarrierPicker
        placeholder={props.placeholder}
        isClearable={props.isClearable}
        flush={props.flush}
        selected={props[props.name]}
        onSelect={(e: any) =>
          props.onChange({ [props.name]: e?.value ?? undefined })
        }
      />
    )
  }
  if (props.type === "fuelType") {
    return (
      <FuelTypePicker
        placeholder={props.placeholder}
        isClearable={props.isClearable}
        flush={props.flush}
        selected={props[props.name]}
        onSelect={(e: any) =>
          props.onChange({ [props.name]: e?.value ?? undefined })
        }
      />
    )
  }

  if (props.type === "monitor_type") {
    return (
      <MonitorTypePicker
        error={props.error}
        label={props.label}
        selected={props.selected}
        onSelect={(e: any) => props.onChange({ [props.name]: e.value })}
      />
    )
  }

  if (props.type === "customer") {
    return (
      <CustomerPicker
        pageSize={props.pageSize}
        showLabel={!!props.label}
        label={props.label}
        flush={props.flush}
        isClearable={props.isClearable}
        placeholder="Customer"
        selected={props[props.name]}
        onSelect={(e: any) => props.onChange({ [props.name]: e?.value })}
      />
    )
  }

  if (props.type === "location") {
    return (
      <CustomerLocationPicker
        selected={props[props.name]}
        customerId={props.customer}
        onSelect={(e: any) => props.onChange({ [props.name]: e.value })}
      />
    )
  }

  if (props.type === "driver") {
    return (
      <Wrapper {...props}>
        <SinglePicker
          isClearable={props.isClearable}
          endpoint="agents/drivers"
          flush={props.flush}
          placeholder={props.placeholder ?? "Choose Driver"}
          getLabel={(driver: any) => driver.business_name || driver.full_name}
          selected={props.driver}
          onSelect={(e: any) => props.onChange({ [props.name]: e.value })}
        />
      </Wrapper>
    )
  }

  if (props.type === "tank_products") {
    return (
      <Wrapper {...props}>
        <TankProductPicker
          errorText={props.errors?.[props.name]}
          prefix={props.prefix}
          tank_id={props.tank_id}
          isDisabled={props.disabled}
          location={props.location}
          selected={props.product ?? props.selected}
          onSelect={(e: any) => {
            props.onChange({ ...e.data })
          }}
        />
      </Wrapper>
    )
  }
  if (props.type === "location_tanks") {
    return (
      <Wrapper {...props}>
        <LocationTankPicker
          controlStyle={props.controlStyle}
          placeholder={props.placeholder}
          errorText={props.errors?.[props.name]}
          tank_id={props.tank_id}
          isDisabled={props.disabled}
          location={props.location}
          selected={props.selected}
          onSelect={(e: any) => props.onChange({ ...e.data })}
        />
      </Wrapper>
    )
  }
  if (props.type === "multi_email")
    return (
      <Wrapper {...props}>
        <MultiEmailInput
          {...props}
          name={props.name}
          emails={props[props.name] ?? ""}
          onChange={props.onChange}
          label={props.noLabel ? "" : props.label}
        />
      </Wrapper>
    )

  if (props.type === "monitors") {
    return (
      <SinglePicker
        canCreate
        endpoint="monitors"
        label={!props.noLabel && props.label}
        flush={props.flush}
        isClearable={props.isClearable}
        placeholder={props.placeholder ?? "Choose Monitor"}
        getLabel={(monitor: any) => `${monitor.id}. ${monitor.ip}`}
        selected={props.monitor}
        onSelect={(e: MONITOR_SELECT) =>
          props.onChange({
            [props.name]: e?.value,
            monitor: e?.data?.id,
            port: e?.data?.port,
            password: e?.data?.password,
            type: e?.data?.type,
            isNewMonitor: e?.__isNew__,
          })
        }
      />
    )
  }

  if (props.type === "checkbox") {
    return (
      <FormInput
        type="checkbox"
        label={props.noLabel ? "" : props.label}
        name={props.name}
        checked={props[props.name]}
        placeholder="Enter your text"
        onChange={(e: any) => {
          props.onChange({ [props.name]: e.target.checked })
        }}
      />
    )
  }

  if (props.type === "terminal") return <TerminalPicker {...props} />

  if (props.type === "all_suppliers") {
    return (
      <div className={cn("flex-c-box", "w-full", props.className)}>
        <ConditionalView condition={!props.noLabel && props.label}>
          <span className={styles.inputLabel}>{props.label}</span>
        </ConditionalView>
        <SinglePicker
          flush={props.flush}
          isClearable={props.isClearable}
          endpoint="suppliers"
          placeholder={props.placeholder ?? "Choose Supplier"}
          labelKey="name"
          selected={props.supplier?.id ?? props.supplier ?? props.selected}
          onSelect={(e: any) => {
            props?.onChange?.({ [props.name]: e?.value ?? "" })
          }}
        />
      </div>
    )
  }

  if (props.type === "benchmark_suppliers") {
    if (!props.product) return <div />
    return (
      <div className={cn("flex-c-box", "w-full", props.className)}>
        <ConditionalView condition={!props.noLabel && props.label}>
          <span className={styles.inputLabel}>{props.label}</span>
        </ConditionalView>
        <SinglePicker
          flush={props.flush}
          isClearable={props.isClearable}
          // endpoint={`best-buy/benchmarks/?product_id=${props.product}&terminal_id=${props.terminal}`}
          endpoint={`best-buy/benchmarks/`}
          nextEndpoint="suppliers"
          placeholder={"Benchmark / Supplier"}
          labelKey="name"
          selected={props.selected}
          onSelect={(e: any) => {
            const key = e?.data?.price?.benchmark ? "benchmark" : "supplier"
            props.onChange({
              [key]: e?.value ?? "",
              price: e?.data?.price?.price,
            })
          }}
        />
      </div>
    )
  }

  if (props.type === "all_products") {
    return (
      <div className={cn("flex-c-box", "w-full", props.className)}>
        <ConditionalView condition={!props.noLabel && props.label}>
          <span className={styles.inputLabel}>{props.label}</span>
        </ConditionalView>
        <SinglePicker
          flush={props.flush}
          isClearable={props.isClearable}
          endpoint="products?ordering=code"
          placeholder={props.placeholder ?? "Choose Product"}
          labelKey="code"
          selected={props.product?.id ?? props.product ?? props.selected}
          onSelect={(e: any) =>
            props?.onChange?.({ [props.name]: e?.value ?? "" })
          }
        />
      </div>
    )
  }

  if (props.type === "source")
    return (
      <Wrapper {...props}>
        <SourcePicker
          flush={props.flush}
          product={props.product}
          terminal={props.terminal}
          placeholder={props.placeholder}
          isClearable={props.isClearable}
          needsTerminal
          selected={props?.selected}
          onSelect={(e: any) => {
            if (props.selected?.supplier === e?.id) return

            props.onChange({
              empty_supplier: !e,
              supplier: e?.id,
              supplier_label: e?.label,
              loading_number_id: null,
              loading_number: null,
              wholesaler: null,
              description: null,
              [props.name]: {
                supplier: e?.id,
                ...e,
                info: e,
                loading_number_id: null,
                loading_number: null,
                wholesaler: null,
                description: null,
              },
            })
          }}
        />
      </Wrapper>
    )

  if (props.type === "loading_number") {
    return (
      <Wrapper {...props}>
        <LoadingNumberPicker
          flush={props.flush}
          errorText={props.errors?.[props.name]}
          terminal={props.terminal ?? props.preferred_source?.terminal}
          supplier={props.preferred_source?.supplier ?? props.supplier}
          product={props.product}
          location={props.location}
          quantity={props?.quantity}
          forcePreselect={props?.forcePreselect}
          placeholder={props.placeholder}
          isClearable={props.isClearable}
          selected={props?.selected}
          onSelect={(e: any) => {
            props.onChange({
              loading_number_id: e?.value,
              loading_number: e?.loading_number,
              wholesaler: e?.wholesaler,
              description: e?.description,
            })
          }}
        />
      </Wrapper>
    )
  }

  if (props.type === "supplier")
    return (
      <div className={cn("flex-c-box", props.className)}>
        <ConditionalView condition={!props.noLabel && props.label}>
          <span className={styles.inputLabel}>{props.label}</span>
        </ConditionalView>
        <SuppliersList
          menuPlacement={props.menuPlacement}
          isClearable={props.isClearable}
          selected={
            props.custom_selected
              ? props.custom_selected(props.selected)
              : props?.selected
          }
          onSelect={(e: any) => props.onChange({ supplier: e })}
        />
      </div>
    )
  if (props.type === "product")
    return (
      <div className={cn("flex-c-box", props.className)}>
        <ConditionalView condition={props.label && props.showLabel}>
          <span
            className={cn(
              "font-bold text-primary-text",
              { "mb-2": !props?.labelMargin },
              props.labelMargin
            )}
          >
            {props.label}
          </span>
        </ConditionalView>
        <ProductsList
          controlStyle={props.controlStyle}
          menuPlacement={props.menuPlacement}
          name={props.name}
          error={props.errors}
          isClearable={props.isClearable}
          flush={props.flush}
          isDisabled={props.disabled}
          selected={props?.selected}
          onSelect={(e: any) =>
            props.onChange({
              product: e?.id,
              product_id: e?.id,
              product_name: e?.label,
            })
          }
        />
      </div>
    )

  if (props.type === "datetime") {
    let value = props.value
    if (props.value?._isAMomentObject && !props.value?._isValid) value = null

    return (
      <Wrapper {...props}>
        <HyperDatepicker
          textValue={props.textValue}
          customDayClass={props.customDayClass}
          onCalendarClose={props.onCalendarClose}
          minDate={props.minDate ?? null}
          maxDate={props.maxDate ?? null}
          minTime={props.minTime ?? null}
          maxTime={props.maxTime ?? null}
          inputClass={cn("custom_list_input", props?.inputClass ?? "")}
          hideAddon={true}
          showTimeSelect
          placeholder={props.placeholder}
          timeFormat="HH:mm"
          tI={props.interval ?? 60}
          dateFormat={props.format ?? "MMMM d, yyyy h:mm aa"}
          timeCaption="time"
          value={
            props?.timezone
              ? new Date(dayjs(value).format("YYYY-MM-DD HH:mm:ss"))
              : value
              ? new Date(value)
              : undefined
          }
          onChange={props.onChange}
        />
      </Wrapper>
    )
  }

  if (props.type === "date") {
    let value = props.value
    if (props.value?._isAMomentObject && !props.value?._isValid) value = null
    return (
      <Wrapper {...props}>
        <ConditionalView condition={props.disabled}>
          <span className="text-center">
            {dayjs(value).format(props.format ?? "MMM D, YYYY")}
          </span>
          <HyperDatepicker
            textValue={props.textValue}
            customDayClass={props.customDayClass}
            inputClass="custom_list_input"
            placeholder={props.placeholder ?? "Date not set"}
            hideAddon={true}
            minDate={props.minDate}
            maxDate={props.maxDate}
            timeFormat="HH:mm"
            tI={props.interval ?? 60}
            dateFormat={props.format ?? "MMM d, yyyy"}
            value={value ? new Date(value) : undefined}
            onChange={props.onChange}
          />
        </ConditionalView>
      </Wrapper>
    )
  }
  if (props.type === "time") {
    let value = props.value
    if (props.value?._isAMomentObject && !props.value?._isValid) value = null

    return (
      <Wrapper {...props}>
        <HyperDatepicker
          textValue={props.textValue}
          disabled={props.disabled}
          inputClass="custom_list_input"
          hideAddon={true}
          showTimeSelect
          showTimeSelectOnly
          timeFormat="HH:mm"
          tI={props.interval ?? 60}
          dateFormat="HH:mm"
          timeCaption="Time"
          value={value ? new Date(value) : undefined}
          onChange={props.onChange}
        />
      </Wrapper>
    )
  }
  if (props.type === "address") {
    return (
      <div className={props.className} key={props.name}>
        <ConditionalView condition={!props.noLabel}>
          <span className={styles.inputLabel}>Address</span>
        </ConditionalView>
        <GoogleAutoComplete
          label={props.defaultValue}
          onSelect={(e: any) => {
            const ret = {
              latitude: e.lat,
              longitude: e.lng,
              address: e.label,
              city: e.city,
              state: e.state,
              zip: e.zipCode,
            }
            if (!e.zipCode) delete ret.zip
            props.onChange(ret)
          }}
        />
      </div>
    )
  }
  if (props.type === "price_input") {
    return <PriceInput {...props} />
  }

  return (
    <div
      className={props.className}
      style={{ position: "relative" }}
      key={props.name}
    >
      <FormInput
        containerClass={`grid ${props.containerClass ?? ""}`}
        className={cn(
          `${styles.inputItem}`,
          {
            [styles.disabledInputItem]: props.disabled,
          },
          props.className
        )}
        min={props.min}
        step={props.step}
        value={props.text_value ?? undefined}
        defaultValue={props.defaultValue}
        rightText={props.rightText}
        label={props.noLabel ? "" : props.label}
        labelClassName={cn("font-bold text-primary-text", props.labelClass)}
        placeholder={props.placeholder ?? props.label}
        errors={props.errors}
        type={props.type}
        name={props.name}
        onChange={props.onChange}
        onBlur={props.onBlur}
        onClick={(e: any) => e.stopPropagation()}
        disabled={props.disabled}
        warnings={props?.warnings}
        onKeyDown={props?.onKeyDown}
      />
      <ConditionalView condition={!!props.error}>
        <>
          <div
            className={classNames(
              `pointer-events-none absolute top-[29px] left-0 bottom-1 right-0 rounded-lg border-[1px] border-solid border-red-500`,
              {
                [props.errorClass]: !!props.errorClass,
              }
            )}
          />
          <span className="text-xs absolute left-0 bottom-[-16px] text-red-500">
            {props.error}
          </span>
        </>
      </ConditionalView>
    </div>
  )
}

export default FormItem
